<template>
  <div class="d-flex flex-column pb-2 pt-2 h-100">
    <div>
      <mdb-input
        class="m-0"
        size="sm"
        outline
        label="Filter..."
        type="text"
        v-model="searchString"
      />
    </div>
    <admin-tab-node-relationships-nodes-harmonica
      class="h-100"
      :read-only="readOnly"
      :groups="filteredRelsByLabel"
      @select="$emit('select', $event)"
      @delete-relationship="$emit('delete-relationship', $event)"
    />
  </div>
</template>

<script>
import { mdbInput } from 'mdbvue'
import {formatDT} from '../utils'
import AdminTabNodeRelationshipsNodesHarmonica from './AdminTabNodeRelationshipsNodesHarmonica'

export default {
  name: 'AdminTabNodeRelationshipsNodes',
  data () {
    return {
      openedPane: null,
      searchString: ''
    }
  },
  props: {
    relsByLabel: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    filteredRelsByLabel: {
      get () {
        return this.relsByLabel.map(group => {
          return Object.assign(
            {},
            group,
            {
              rels: Array.from(group.rels).filter(rel => {
                const node = rel.node
                return node.name ? node.name.toLowerCase().includes(this.searchString.toLowerCase()) : false
              })
            }
          )
        })
      }
    }
  },
  methods: {
    onPaneClicked (num) {
      this.openedPane = this.openedPane === num ? null : num
    },
    formatDateTime (obj) {
      return formatDT(obj)
    }
  },
  components: {
    AdminTabNodeRelationshipsNodesHarmonica,
    mdbInput
  }
}
</script>

<style lang="sass" scoped>
.collapse-toggler
  font-weight: bold
  width: 100%
  background-color: transparent!important
  border: 2px solid #dee2e6!important
  cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/AdminTabNodeRelationshipsNodes.vue